import React from "react";
import { SegmentedControl } from "@amzn/awsui-components-react";

import type { PipelineFilterSelection } from "./pipelineFilterVisibility";

export interface PipelineFilterProps {
  readonly value: PipelineFilterSelection;
  readonly onChange: (next: PipelineFilterSelection) => void;
}

export const PipelineFilter: React.FC<PipelineFilterProps> = ({
  value,
  onChange,
}) => (
  <SegmentedControl
    selectedId={value}
    options={[
      { id: "ALL", text: "All" },
      { id: "LVS", text: "LVS" },
      { id: "HATTRICK", text: "Hattrick" },
    ]}
    onChange={({ detail }) =>
      onChange(detail.selectedId as PipelineFilterSelection)
    }
  />
);
